import image1 from "./1.jpg"
import image2 from "./2.jpg"
import image3 from "./3.jpg"
import image4 from "./4.jpg"
import image5 from "./5.jpg"
import image6 from "./6.jpg"
import image7 from "./7.jpg"
import image9 from "./9.jpg"
import image11 from "./11.jpg"
import image12 from "./12.jpg"
import image13 from "./13.jpg"
import image14 from "./14.jpg"
import image15 from "./15.jpg"
import image16 from "./16.jpg"
import image17 from "./17.jpg"
import image18 from "./18.jpg"
import image19 from "./19.jpg"
import image20 from "./20.jpg"
import image21 from "./21.jpg"
import image22 from "./22.jpg"
import image23 from "./23.jpg"
import image24 from "./24.jpg"
import image25 from "./25.jpg"
import image26 from "./26.jpg"

export default [{
    src: image2,
    width: 6,
    height: 8,
}, {
    src: image3,
    width: 6,
    height: 8,
},{
    src: image4,
    width: 6,
    height: 6,
}, {
    src: image5,
    width: 6,
    height: 8,
}, {
    src: image6,
    width: 8,
    height: 8,
}, {
    src: image7,
    width: 6,
    height: 8,
}, {
    src: image9,
    width: 6,
    height: 8,
}, {
    src: image11,
    width: 8,
    height: 8,
}, {
    src: image12,
    width: 8,
    height: 8,
}, {
    src: image13,
    width: 6,
    height: 8,
}, {
    src: image14,
    width: 6,
    height: 8,
},{
    src: image15,
    width: 6,
    height: 8,
}, {
    src: image16,
    width: 6,
    height: 6,
}, {
    src: image17,
    width: 6,
    height: 6,
},{
    src: image18,
    width: 6,
    height: 6,
}, {
    src: image19,
    width: 6,
    height: 8,
}, {
    src: image1,
    width: 6,
    height: 8,
},{
    src: image20,
    width: 6,
    height: 6,
}, {
    src: image21,
    width: 6,
    height: 8,
}, {
    src: image22,
    width: 6,
    height: 8,
},  {
    src: image23,
    width: 6,
    height: 8,
},{
    src: image24,
    width: 6,
    height: 6,
}, {
    src: image25,
    width: 6,
    height: 6,
}, {
    src: image26,
    width: 6,
    height: 6,
}]